import React, { FC, useMemo } from "react";
import { Button, Container, Fade, Grid, Link, Typography } from "@mui/material";

import { ChevronLeft } from "@mui/icons-material";
import useAuthentication from "../hooks/useAuthentication";
import { COLORS } from "../styles/colors";
import Logo from "./svg/Logo";
import useIsPortal from "../hooks/useIsPortal";
import { useNavigate } from "react-router-dom";

type TablePageHeaderProps = {
  drawerOpen: boolean;
  onNameClick: () => void;
};

const TablePageHeader: FC<TablePageHeaderProps> = ({
  onNameClick,
  drawerOpen,
}) => {
  const { user } = useAuthentication();
  const { isPortal } = useIsPortal();
  const navigate = useNavigate();

  const backLinkProps = useMemo(() => {
    if (isPortal) {
      return { href: "/" };
    } else {
      return { component: "button", onClick: () => navigate(-1) };
    }
  }, [isPortal]);

  return (
    <Container maxWidth={false} style={{ height: "60px" }} disableGutters>
      <Grid container justifyContent="space-between" alignItems="start">
        <Grid item>
          <Grid container style={{ height: "100%" }} sx={{ pr: 1, pl: 0 }}>
            <Grid item>
              <Link {...backLinkProps}>
                <Button startIcon={<ChevronLeft />}>Zurück</Button>
              </Link>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Fade in={!drawerOpen}>
            <Grid
              container
              // justifyContent="flex-end"
              alignItems="center"
              style={{ height: "100%" }}
              sx={{ pr: 0, pl: 2 }}
            >
              <Grid
                item
                onClick={() => onNameClick()}
                style={{ cursor: "pointer" }}
              >
                <Typography variant="h6">
                  {user?.vorname} {user?.nachname}
                </Typography>
              </Grid>
              <Grid item>
                <span
                  onClick={() => onNameClick()}
                  style={{ cursor: "pointer" }}
                >
                  <Logo style={{ height: "50px" }} fill={COLORS.tuv_r_blue} />
                </span>
              </Grid>
            </Grid>
          </Fade>
        </Grid>
      </Grid>
    </Container>
  );
};

export default TablePageHeader;
